// src/components/PreShip.tsx
import React, { useState, useEffect, useCallback } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Button } from "../ui/button";
import { cn } from "@/lib/utils";
import { ChevronsRight, ChevronsLeft, ChevronDown, ChevronRight } from "lucide-react";
// import PreShipLean from "./pre-ship-lean";
// import PreShipFTL from "./pre-ship-ftl";
// import PreShipUnitLoadPosition from "./pre-ship-unit-load-position";
// import PreShipUnitLoadHeight from "./pre-ship-unit-load-height";
// import PreShipRQL from "./pre-ship-RQL";
import Footer from "../footer";
import { RootState } from "@/redux/store";
import { useSelector, useDispatch } from 'react-redux';
import { setActivePallet } from "@/redux/slices/pallet/palletSlice";
import Lean from "../common-components/Lean";
import ShipTestTruckLayout from "./ship-test-truck-layout";
import Ftl from "../common-components/Ftl";
import UnitLoadHeight from "../common-components/UnitLoadHeight";
import UnitLoadPosition from "../common-components/UnitLoadPositionj";
import Rql from "../common-components/Rql";
import { endStatus } from "@/lib/utils";
import EditBanner from "../common-components/EditBanner";
import { showSuccessToast, showErrorToast } from "@/components/toast/toast";
import { Skeleton } from "@/components/ui/skeleton";
// import { usePostShipMutation } from "@/redux/slices/post-ship/post-ship-api-slice";

interface PostShipProps {
  projectId?: string;
  isOffline?: boolean;
  onOfflineSubmit?: (values: any) => Promise<void>;
}

export default function PostShip({
  projectId,
  isOffline,
  onOfflineSubmit
}: PostShipProps) {
  const { activePallet, palletTypes } = useSelector((state: RootState) => state.pallets);
  const dispatch = useDispatch();
  const [expandedTabs, setExpandedTabs] = useState<{ [key: string]: boolean }>({});
  const { shippingModes } = useSelector((state: RootState) => state.define);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [isLoading, setIsLoading] = useState(false)
  const [isInitialLoading, setIsInitialLoading] = useState(true);
  const [isTabContentLoading, setIsTabContentLoading] = useState(false);
  const paths = [
    // {
    //   id: 1,
    //   tabName: "Ship Test Truck Layout",
    //   tabContent: <ShipTestTruckLayout />,
    // },
    {
      id: 2, displayTabName: "Post-Ship Lean", tabName: "Postship Lean", tabContent: <Lean  week={[
        "Post Ship",
        "Stack start(stacked+30m)",
        "Stack Week-1",
        "Stack Week-2",
        "Stack Week-3",
        "Stack Week-4 (unstacking+30M)"]} variant='postShip' setIsLoading={setIsLoading} />
    },
    {
      id: 3, displayTabName: "Post-Ship FTL", tabName: "Postship FTL", tabContent: <Ftl variant='postShip' week={[
        "Post Ship",
        "Stack start(stacked+30m)",
        "Stack Week-1",
        "Stack Week-2",
        "Stack Week-3",
        "Stack Week-4 (unstacking+30M)"]} setIsLoading={setIsLoading} />
    },
    {
      id: 4, displayTabName:"Post-Ship Position (Walk)", tabName: "Postship Unit Load Position", tabContent: <UnitLoadPosition week={[
        "Post Ship",
        "Stack start(stacked+30m)",
        "Stack Week-1",
        "Stack Week-2",
        "Stack Week-3",
        "Stack Week-4 (unstacking+30M)"]} variant='postShip' setIsLoading={setIsLoading} />
    },
    {
      id: 5, displayTabName: "Post-Ship Height", tabName: "Postship Unit Load Height", tabContent: <UnitLoadHeight week={[
        "Post Ship",
        "Stack start(stacked+30m)",
        "Stack Week-1",
        "Stack Week-2",
        "Stack Week-3",
        "Stack Week-4 (unstacking+30M)"]} variant="postShip" setIsLoading={setIsLoading} />
    },
    { id: 6, displayTabName: "Post-Ship RQL", tabName: "Postship RQL", tabContent: <Rql variant="postShip" setIsLoading={setIsLoading} /> },
  ];
  const [selectedTab, setSelectedTab] = useState(paths[0].tabName);
  const [selectedPallet, setSelectedPallet] = useState(palletTypes[0] && palletTypes[0]?.id?.toString() || "");
  const [isNav, setIsNav] = useState(true);
  const [isEditing, setIsEditing] = useState(false)
  // const [submitPostShipData] = usePostShipMutation();
  useEffect(() => {
    if (palletTypes.length > 0) {
      setSelectedPallet(palletTypes[0]?.id?.toString() || "");
      dispatch(setActivePallet(palletTypes[0]));

      // Set the first tab as expanded
      setExpandedTabs({ [paths[0].tabName]: true });
    }

    // Simulate initial loading - replace with actual loading state in production
    const timer = setTimeout(() => {
      setIsInitialLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, [palletTypes, dispatch]);

  const toggleTabExpansion = (tabName: string) => {
    setExpandedTabs(prev => ({ ...prev, [tabName]: !prev[tabName] }));
  };

  useEffect(() => {
    if (!isOffline) {
      setIsEditing(false)
    }
  }, [selectedTab])
  const handleFormChange = useCallback((hasChanges: boolean) => {
    setHasUnsavedChanges(hasChanges);
  }, []);

  const saveCurrentForm = useCallback(async ({ fromTab }: { fromTab?: boolean }) => {
    if (activePallet) {
      const leanTable = document.getElementById(`lean-table-${activePallet.id}`);
      if (leanTable) {
        const submitButton = leanTable.querySelector('button[type="submit"]');
        if (submitButton) {
          (submitButton as HTMLButtonElement).click();
        }
      }
      const ftlTable = document.getElementById(`ftl-table-${activePallet?.id}`);
      if (ftlTable) {
        const submitButton = ftlTable.querySelector('button[type="submit"]');
        if (submitButton) {
          (submitButton as HTMLButtonElement).click();
        }
      }
      const loadPostionTable = document.getElementById(`unit-load-position-table-${activePallet?.id}`);
      if (loadPostionTable) {
        const submitButton = loadPostionTable.querySelector('button[type="submit"]');
        if (submitButton) {
          (submitButton as HTMLButtonElement).click();
        }
      }
      const loadHeightTable = document.getElementById(`unit-load-height-table-${activePallet?.id}`);
      if (loadHeightTable) {
        const submitButton = loadHeightTable.querySelector('button[type="submit"]');
        if (submitButton) {
          (submitButton as HTMLButtonElement).click();
        }
      }
      const rqlTable = document.getElementById(`rql-table-${activePallet?.id}`);
      if (rqlTable) {
        const submitButton = rqlTable.querySelector('button[type="submit"]');
        if (submitButton) {
          (submitButton as HTMLButtonElement).click();
        }
      }

    } else {
      for (let mode of shippingModes) {
        const postShipTruckLayout = document.getElementById(`postShipTruckLayout-${mode?.id}`);
        if (postShipTruckLayout) {
          const submitButton = postShipTruckLayout.querySelector('button[type="submit"]');
          if (submitButton) {
            (submitButton as HTMLButtonElement).click();
          }
        }
      }

    }

    setHasUnsavedChanges(false);
  }, [activePallet, selectedTab, hasUnsavedChanges]);

  const handleTabSelection = async (tabName: string, palletId: string) => {
    setIsTabContentLoading(true);
    if (hasUnsavedChanges) {
      await saveCurrentForm({ fromTab: true });
    }
    setSelectedTab(tabName);
    setSelectedPallet(palletId);
    dispatch(setActivePallet(palletTypes.find(p => p.id?.toString() === palletId) || null));

    // Simulate tab content loading - replace with actual loading state in production
    setTimeout(() => {
      setIsTabContentLoading(false);
    }, 500);
  };

  useEffect(() => {
    if (isOffline) {
      setIsEditing(true)
    }
  }, [isOffline])

  // Reusable component for content skeletons
  const TableContentSkeleton = () => (
    <div className="space-y-6 w-full animate-pulse">
      <div className="flex justify-between items-center">
        <Skeleton className="h-8 w-48" />
        <Skeleton className="h-10 w-32" />
      </div>

      {/* Table header skeleton */}
      <div className="border rounded-md overflow-hidden">
        <div className="border-b bg-gray-50">
          <div className="grid grid-cols-6 p-3">
            <Skeleton className="h-6 w-full mx-2" />
            {Array(5).fill(0).map((_, i) => (
              <Skeleton key={i} className="h-6 w-full mx-2" />
            ))}
          </div>
        </div>

        {/* Table rows skeleton */}
        <div className="p-2">
          {[1, 2, 3, 4, 5].map((i) => (
            <div key={i} className="grid grid-cols-6 gap-2 p-2 border-b last:border-0">
              <Skeleton className="h-10 w-full" />
              {Array(5).fill(0).map((_, j) => (
                <Skeleton key={j} className="h-10 w-full" />
              ))}
            </div>
          ))}
        </div>
      </div>

      {/* Action buttons skeleton */}
      <div className="flex justify-end space-x-3">
        <Skeleton className="h-10 w-24" />
        <Skeleton className="h-10 w-24" />
      </div>
    </div>
  );

  // const handleSubmit = async (values: any) => {
  //   if (isOffline && onOfflineSubmit) {
  //     await onOfflineSubmit(values);
  //     return;
  //   }

  //   try {
  //     await submitPostShipData({
  //       projectId,
  //       ...values
  //     });
  //     showSuccessToast("Post-ship data saved successfully");
  //   } catch (error) {
  //     console.error(error);
  //     showErrorToast("Failed to save post-ship data");
  //   }
  // };

  if (isInitialLoading) {
    return (
      <div className="w-full flex h-[calc(100vh-140px)]">
        {/* Sidebar skeleton */}
        <div className="w-[200px] h-full bg-light-blue flex flex-col items-start justify-start pt-10 overflow-y-auto">
          {paths.map((path, index) => (
            <div key={index} className="w-full mb-4 px-4">
              <Skeleton className="h-12 w-full rounded-md" />
              {index === 0 && (
                <div className="pl-8 py-2 space-y-3 mt-2">
                  {[1, 2, 3].map((i) => (
                    <Skeleton key={i} className="h-16 w-full rounded-md" />
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Main content skeleton */}
        <div className="flex-1 overflow-hidden">
          <div className="p-8">
            <TableContentSkeleton />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full flex h-[calc(100vh-140px)] overflow-x-auto">
      <Tabs
        defaultValue={`${paths[0].tabName}-${palletTypes[0]?.id}`}
        className="w-full flex"
        value={`${selectedTab}-${selectedPallet}`}
        onValueChange={(value) => {
          const [tabName, palletId] = value.split('-');
          handleTabSelection(tabName, palletId);
        }}
      >
        {isNav ? (
          <TabsList className="w-[200px] relative z-50 h-full bg-light-blue flex flex-col justify-start py-8 overflow-y-auto">
            <ChevronsLeft onClick={() => setIsNav(!isNav)} className="cursor-pointer absolute top-2 right-2 text-blue" />
            {paths.map((path) => (
              <div key={path.id} className="w-full mb-2">
                <TabsTrigger
                  value={`${path.tabName}-${activePallet?.id}`}
                  className={cn(
                    "w-full justify-between px-6 py-4 text-left text-lg font-semibold",
                    selectedTab === path.tabName ? "bg-bgBlue text-blue" : ""
                  )}
                  onClick={() => toggleTabExpansion(path.tabName)}
                >
                  <span>{path.displayTabName}</span>
                  {expandedTabs[path.tabName] ? <ChevronDown className="text-blue min-h-6 min-w-6" /> : <ChevronRight className=" min-h-6 min-w-6" />}
                </TabsTrigger>
                {expandedTabs[path.tabName] && (
                  <div className="pl-8 py-2 bg-white">
                    {palletTypes.map((pallet) => (
                      <TabsTrigger
                        key={`${path.tabName}-${pallet.id}`}
                        value={`${path.tabName}-${pallet.id}`}
                        className={cn(
                          "w-full justify-start px-4 py-2 text-sm",
                          selectedTab === path.tabName && selectedPallet === pallet.id?.toString()
                            ? "bg-blue/20 text-blue font-semibold"
                            : "hover:bg-gray-100"
                        )}
                        onClick={() => handleTabSelection(path.tabName, pallet.id?.toString() || "")}
                      >
                        <div className="flex flex-col gap-1">
                          <div>{pallet.variant}</div>
                          <div className="">{pallet.name}</div>
                        </div>
                      </TabsTrigger>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </TabsList>
        ) : (
          <TabsList className="w-[40px] relative z-50 h-full bg-light-blue flex flex-col items-start justify-start pt-10 overflow-y-auto">
            <ChevronsRight onClick={() => setIsNav(!isNav)} className="cursor-pointer absolute top-2 right-2 text-blue" />
          </TabsList>
        )}
        <div className="flex-1 overflow-y-auto pb-[90px]">
          {/* {!isOffline && paths.map((path) => (
            selectedTab === path.tabName && (
              <EditBanner
                key={path.id}
                stage={'postShip'}
                palletId={1}
                component={path.tabName}
                onEditStateChange={setIsEditing}
              />
            )
          ))} */}
          {paths.map((path) => (
            palletTypes.map((pallet) => (
              <TabsContent
                key={`${path.tabName}-${pallet.id}`}
                value={`${path.tabName}-${pallet.id}`}
                className={cn(
                  " z-[-1000]  overflow-y-auto p-3 ",
                  path.tabName !== "Ship Test Truck Layout" && "space-y-4"
                )}
              >
                {isTabContentLoading && selectedTab === path.tabName && selectedPallet === pallet.id?.toString() ? (
                  <TableContentSkeleton />
                ) : (
                  React.cloneElement(path.tabContent as React.ReactElement, {
                    palletId: pallet.id,
                    isEditing,
                    onFormChange: handleFormChange,
                    isOffline,
                    tabName: path.tabName,
                    stage: 'postShip',
                    setIsLoading: setIsLoading,
                    onOfflineSubmit: async (values: any) => {
                      if (isOffline && onOfflineSubmit) {
                        await onOfflineSubmit({
                          type: 'postShip',
                          component: path.tabName,
                          palletId: pallet.id,
                          data: values
                        });
                      }
                    }
                  })
                )}
              </TabsContent>
            ))
          ))}
        </div>
      </Tabs>
      <Footer
        layout
        isLoading={isLoading}
        onSubmit={() => saveCurrentForm({ fromTab: false })}
        hasUnsavedChanges={hasUnsavedChanges}
      />
    </div>
  );
};

